import React, { useEffect, useState } from "react";
import request from "axios";
import AccountRefsTable from "./accountRefsTable";

const AccountRefsApi = ({ token, ...props }) => {
  const [rows, setRows] = useState([]);
  const [saving, setSaving] = useState(false);
  const [loading, setLoading] = useState(true);
  const [saveError, setSaveError] = useState(null);

  useEffect(() => {
    request
      .get(`${process.env.REACT_APP_CD_API_URL}/accountReferences`, {
        headers: { Authorization: `Bearer ${token}` }
      })
      .then(({ data }) => setRows(data.data.recordset))
      .then(() => setLoading(false));
  }, []);

  const updateRows = newRows => setRows(newRows);

  const saveChanges = () => {
    setSaveError(null);
    setSaving(true);
    return request
      .post(
        `${process.env.REACT_APP_CD_API_URL}/accountReferences`,
        { updatedRows: rows },
        {
          headers: { Authorization: `Bearer ${token}` }
        }
      )
      .catch(err => setSaveError(err.message))
      .then(() => setSaving(false));
  };

  return (
    <AccountRefsTable
      loading={loading}
      rows={rows}
      updateRows={updateRows}
      saveChanges={saveChanges}
      saving={saving}
      saveError={saveError}
      {...props}
    />
  );
};

export default AccountRefsApi;
